import { createStore } from 'vuex'

export default createStore({
  state: {
    cart: [],
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
